
import { ref, defineComponent, watch } from "vue";
import InputText from "primevue/inputtext";
import axios from "axios";
import Ripple from "primevue/ripple";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import { useRouter, useRoute } from "vue-router";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import Editor from "primevue/editor";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "RefundMain",
  components: {
    InputText,
    Button,
    Skeleton,
    Accordion,
    AccordionTab,
    Dropdown,
    Editor,
    Dialog,
    Checkbox,
  },
  props: ["pnr", "guid", "ticketNumber"],
  setup(props) {
    const isLoading = ref(false);
    const loadingWhileDialog = ref(false);
    const checkedTickets = ref<any>([]);
    const checkTicketsError = ref(false);
    const display = ref(false);
    const choosedTickets = ref<any>([]);
    const selectedReason = ref({ name: "" });
    const description = ref("");
    const subIndex = ref([
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
    ]);
    const reasons = ref([
      { name: "Добровольный возврат" },
      { name: "Отмена или задержка рейса" },
      { name: "Болезнь пассажира или члена его семьи" },
      { name: "Иное" },
    ]);
    const isMailInvalid = ref(false);
    const isPhoneInvalid = ref(false);
    const isReasonInvalid = ref(false);
    const router = useRouter();
    const route = useRoute();
    const passMail = ref("");
    const passPhone = ref("");
    const reason = ref("");
    const loading = ref(false);
    const order = ref<any | null>(null);
    const checkedOrder = ref(null);
    const error = ref(null);
    const files = ref<any | null>(null);
    const wrongFileFormat = ref(false);
    const maxFileCount = ref(false);
    const fileSizeEx = ref(false);
    const checkBeforeSumbit = ref(true);
    const showAttachedFiles = ref(false);
    const adjError = ref(false);
    const allUnchecked = ref(false);
    const getOrderForRefund = async () => {
      isLoading.value = true;
      loadingWhileDialog.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetOrderForRefund?guid=${props.guid}&ticketNumber=${props.ticketNumber}`
        );
        if (json.data) {
          let fetchedOrders = await json.data;
          console.log(fetchedOrders);
          if (fetchedOrders.offerId) {
            router.replace({
              name: "Offer",
              params: { offerId: fetchedOrders.offerId[0] },
            });
          } else {
            order.value = fetchedOrders;
            console.log(order.value);

            checkedOrder.value = fetchedOrders;

            passPhone.value = fetchedOrders.info.Phone.Number;
            passMail.value = fetchedOrders.info.EMail;
            if (order.value.customers.length > 0) {
              checkedTickets.value.push(props.ticketNumber);
              display.value = true;
            } else {
              loadingWhileDialog.value = false;
              isLoading.value = false;
            }
          }
        } else {
          console.log("error!");
          isLoading.value = false;
        }

        isLoading.value = false;
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    const rerouteToSuccess = function (id: number) {
      router.replace({
        name: "Success",
        params: { requestNumber: id },
      });
    };
    watch([passMail, passPhone, selectedReason], (newValue, oldValue) => {
      if (isMailInvalid.value == true && passMail.value) {
        isMailInvalid.value = false;
      }
      if (isPhoneInvalid.value == true && passPhone.value) {
        isPhoneInvalid.value = false;
      }
      if (isReasonInvalid.value == true && selectedReason.value.name) {
        isReasonInvalid.value = false;
      }
    });
    const submitRefund = async (
      order: any,
      mail: string,
      phone: string,
      reason: string,
      pnr: string,
      description: string
    ) => {
      let checked = "";

      for (let i = 0; i < order.customers.length; i++) {
        for (let j = 0; j < order.customers[i].customer.Segments.length; j++) {
          if (order.customers[i].customer.Segments[j].IsNeeded == true) {
            if (checked.length > 0) {
              checked += ",";
            }
            checked += order.customers[i].customer.Segments[j].Id.toString();
          }
        }
      }

      let reqParams = {
        segmentIds: checked,
        email: mail,
        phone: phone,
        reason: reason,
        pnr: pnr,
        description: description,
      };
      let bodyFormData = new FormData();
      let finalParams = JSON.stringify(reqParams);
      const blob = new Blob([finalParams], { type: "application/json" });
      bodyFormData.append("Details", blob);
      if (files.value) {
        files.value.files.forEach((el: any) => {
          bodyFormData.append(el.name, el, el.name);
        });
      }
      if (!checked) {
        allUnchecked.value = true;
      } else {
        allUnchecked.value = false;
      }
      if (
        maxFileCount.value ||
        fileSizeEx.value ||
        wrongFileFormat.value ||
        !checked
      ) {
        return;
      } else {
        loading.value = true;
        try {
          axios({
            method: "POST",
            url: `https://www.biletdv.ru/customer/IBEServices/SaveOffer`,
            data: bodyFormData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }).then((res) => {
            if (res.status == 200) {
              loading.value = false;
              rerouteToSuccess(res.data.id);
            }
          });
        } catch (err) {
          if (err.response.status == 401) {
            store.dispatch("auth/logout");
            router.push("/login");
          }
        }
      }
    };
    return {
      passMail,
      passPhone,
      reason,
      isLoading,
      loading,
      order,
      error,
      getOrderForRefund,
      checkedOrder,
      submitRefund,
      router,
      route,
      rerouteToSuccess,
      isMailInvalid,
      isPhoneInvalid,
      isReasonInvalid,
      reasons,
      selectedReason,
      description,
      subIndex,
      files,
      wrongFileFormat,
      maxFileCount,
      fileSizeEx,
      checkBeforeSumbit,
      showAttachedFiles,
      adjError,
      allUnchecked,
      checkTicketsError,
      checkedTickets,
      display,
      loadingWhileDialog,
      choosedTickets,
    };
  },
  created() {
    this.getOrderForRefund();
  },
  methods: {
    tikectsForRefund() {
      if (this.checkedTickets.length == 0) {
        this.checkTicketsError = true;
      } else {
        for (let i = 0; i < this.checkedTickets.length; i++) {
          for (let j = 0; j < this.order.customers.length; j++) {
            if (
              this.checkedTickets[i] ==
              this.order.customers[j].customer.TicketNumber
            ) {
              this.choosedTickets.push(this.order.customers[j]);
            }
          }
        }
        this.isLoading = false;
        this.loadingWhileDialog = false;
        this.display = false;
        console.log(this.checkedTickets);
        console.log(this.choosedTickets);
      }
    },
    handleFileUpload() {
      if (this.files !== null) {
        let filesSize = 0;
        if (this.files.files.length > 0) {
          this.showAttachedFiles = true;
        } else {
          this.showAttachedFiles = false;
        }
        for (let i = 0; i < this.files.length; i++) {
          if (this.files.files[i].size > 10485760) {
            this.fileSizeEx = true;
          } else {
            this.fileSizeEx = false;
          }
          if (
            this.files.files[i].type !== "image/png" &&
            this.files.files[i].type !== "image/jpg" &&
            this.files.files[i].type !== "image/jpeg" &&
            this.files.files[i].type !== "image/pjp" &&
            this.files.files[i].type !== "image/pjpeg" &&
            this.files.files[i].type != "application/pdf" &&
            this.files.files[i].type !== "image/tiff"
          ) {
            console.log("must be true" + this.files.files[i].type);
            this.wrongFileFormat = true;
          } else {
            console.log("must be false" + this.files.files[i].type);
            this.wrongFileFormat = false;
          }

          filesSize += this.files.files[i].size;
        }
        if (filesSize > 22020096) {
          this.fileSizeEx = true;
        } else {
          this.fileSizeEx = false;
        }
        if (this.files.files.length > 10) {
          this.maxFileCount = true;
        } else {
          this.maxFileCount = false;
        }
        if (this.files.files.length == 0) {
          this.wrongFileFormat = false;
        }
        if (this.maxFileCount || this.fileSizeEx || this.wrongFileFormat) {
          this.checkBeforeSumbit = false;
        } else {
          this.checkBeforeSumbit = true;
        }
        console.log(this.files.files[0]);
        console.log(this.wrongFileFormat);
      }
    },
    getWeekDay(date: any) {
      let days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
      let weekDay = new Date(date);
      return days[weekDay.getDay()];
    },
    getDate(date: any) {
      let month = [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ];
      let monthNum = new Date(date);
      return monthNum.getDate() + " " + month[monthNum.getMonth()];
    },
    nameCaseChanger(name: string): string {
      let splitedName = name.split(" ");
      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        normalName += firstLetterUpperCase + " ";
      }
      return normalName;
    },
    nameChangerForDialog(name: string): string {
      let splitedName = name.split(" ");

      let firstLetterUpperCase = "";
      let normalName = "";
      for (let i = 0; i < splitedName.length; i++) {
        firstLetterUpperCase =
          splitedName[i][0].toUpperCase() +
          splitedName[i].slice(1).toLowerCase();
        if (i + 1 == splitedName.length) {
          normalName += firstLetterUpperCase;
        } else {
          normalName += firstLetterUpperCase + " ";
        }
      }
      let splitedNormalName = normalName.split(" ");
      console.log(splitedNormalName);
      let nameForDialog = "";
      if (splitedNormalName.length == 3) {
        nameForDialog =
          splitedNormalName[0] +
          " " +
          splitedNormalName[1][0] +
          "." +
          splitedNormalName[2][0] +
          ".";
      } else {
        nameForDialog =
          splitedNormalName[0] + " " + splitedNormalName[1][0] + ".";
      }

      return nameForDialog;
    },
    changeCheck(seg: any, customerId: any, subIndex: any, order: any) {
      // seg.IsNeeded = !seg.IsNeeded;
      console.log("order.customers:",order.customers);
      var cust = order.customers.find((x: { customer: { Id: any; }; }) => x.customer.Id === customerId);
      if (seg.IsNeeded == false) 
      {
        for (let i = subIndex - 1; i < cust.customer.Segments.length; i++) 
        {
          cust.customer.Segments[i].IsNeeded = true;
          console.log("s1:",cust.customer.Segments[i]);
        }
      } 
      else if (seg.IsNeeded == true) 
      {
        for (let i = subIndex - 1; i >= 0; i--) {
          cust.customer.Segments[i].IsNeeded = false;
          console.log("s2:",cust.customer.Segments[i]);
        }
      }
      console.log("s3:",seg);
      console.log("choosedTickets:", this.choosedTickets);
      this.allUnchecked = false;
    },
    
    submitCheck() {
      if (
        this.passMail == "" &&
        this.passPhone == "" &&
        this.selectedReason.name == ""
      ) {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.passPhone == "") {
        this.isMailInvalid = true;
        this.isPhoneInvalid = true;
      } else if (this.passPhone == "" && this.selectedReason.name == "") {
        this.isPhoneInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "" && this.selectedReason.name == "") {
        this.isMailInvalid = true;
        this.isReasonInvalid = true;
      } else if (this.passMail == "") {
        this.isMailInvalid = true;
      } else if (this.passPhone == "") {
        this.isPhoneInvalid = true;
      } else if (this.selectedReason.name == "") {
        console.log(this.selectedReason);
        this.isReasonInvalid = true;
      } else {
        this.isMailInvalid = false;
        this.isPhoneInvalid = false;
        this.isReasonInvalid = false;
        this.submitRefund(
          this.order,
          this.passMail,
          this.passPhone,
          this.selectedReason.name,
          this.pnr,
          this.description
        );
      }
    },
  },
  directives: {
    ripple: Ripple,
  },
});
